import { mainSiteUrl } from '@/mocks/categories';

export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimal%20desk%20setup%20with%20open%20laptop%20showing%20organized%20data%20grid%20surrounded%20by%20curated%20fashion%20pieces%20including%20folded%20sweater%20and%20sneakers%20on%20light%20oak%20surface%20gentle%20morning%20sunlight%20from%20large%20window%20warm%20natural%20tones%20scandinavian%20workspace%20aesthetic&width=700&height=500&seq=what-is-img-002&orientation=landscape&nocache=true"
                alt="Itaobuy Spreadsheet Italia - Cos'è"
                title="Itaobuy Spreadsheet spiegato"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="lg:w-1/2">
            <span className="inline-block text-xs font-medium text-primary-600 uppercase tracking-widest mb-3">
              Cos&apos;&egrave;
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-5">
              Cos&apos;&egrave; Itaobuy Spreadsheet?
            </h2>
            <div className="space-y-4 text-foreground-600 leading-relaxed text-sm md:text-base">
              <p>
                <strong>Itaobuy Spreadsheet</strong> &egrave; una raccolta organizzata di prodotti selezionati che permette agli utenti di trovare rapidamente articoli interessanti, confrontare informazioni e analizzare la qualit&agrave; attraverso dati strutturati. Il nostro <strong>itaobuy spreadsheet italiano</strong> offre una panoramica completa delle migliori opportunit&agrave; di acquisto.
              </p>
              <p>
                Con l&apos;<strong>itaobuy products list</strong> puoi accedere a centinaia di prodotti organizzati per categoria, con foto QC, recensioni e informazioni dettagliate per fare scelte d&apos;acquisto pi&ugrave; consapevoli e sicure.
              </p>
              <p>
                L&apos;<strong>itaobuy sheet</strong> viene aggiornato regolarmente per garantirti sempre i dati pi&ugrave; recenti sui prodotti disponibili, aiutandoti a risparmiare tempo e a evitare brutte sorprese durante i tuoi acquisti online.
              </p>
            </div>
            <div className="flex flex-wrap gap-3 mt-6">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>Accedi al database</span>
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
              <a
                href="/guida-itaobuy-spreadsheet"
                className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-background-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>Leggi la guida SEO</span>
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}